import React from "react";
import { connect } from "react-redux";
import { prop, sortBy, isNil } from "ramda";
import Select from "react-select";
import { LocalDate } from "js-joda";
import { stringify } from "query-string";
import { loadCommunicators, searchCommunications } from "./monitorActions";
import DateRange from "../../common/components/DateRange";
import { RANGE_CUSTOM, RANGE_BLANK } from "../../common/components/DateRangeSelector";
import { COMPLIANCE_COMMUNICATIONS_ROUTE } from "../../AppRouter";

const labelStyle = {display: "inline-block", marginBottom: 20, marginRight: 10};
const filterBlockStyle = {display: "inline-block", marginRight: 30};
const downloadIcon = process.env.IS_IN_WEBPACK ? require("../../../images/download-icon@2x.png") : "";

class CommunicationsFilter extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCommunicators();
    }

    render() {
        const hasPeriod = this.props.periodStart && this.props.periodEnd;
        const period = hasPeriod ? RANGE_CUSTOM(LocalDate.parse(this.props.periodStart), LocalDate.parse(this.props.periodEnd))
                                 : RANGE_BLANK;

        return (
            <div style={{padding: 10, fontSize: "14px"}}>
                <div style={filterBlockStyle}>
                    <label style={labelStyle}>Communicated By</label>
                    <div style={{display: "inline-block", position: "relative", top: "0.9em"}}>
                        <Select className="x-communicator-selection"
                            options={ sortBy(prop("name"), this.props.communicators).map(c => ({ value: c.id, label: c.name })) }
                            value={this.props.selectedCommunicator}
                            onChange={this.props.onCommunicatorChanged} />
                    </div>
                </div>

                <div style={filterBlockStyle}>
                    <label style={labelStyle}>In Date Range</label>
                    <DateRange onChange={this.props.onPeriodChanged} value={period}/>
                </div>

                <div style={{float: "right", paddingTop: "22px"}}>
                    <a style={{ color: "#0078E7", textDecoration: "none" }}
                       href="/disclosure/api/export-communications">
                        <img src={downloadIcon}
                             style={{ height: "14px", position: "relative", top: "3px", left: "-4px" }}/>
                        Download all communications
                    </a>
                </div>
            </div>
        );
    }
}
CommunicationsFilter.propTypes = {
    communicators: React.PropTypes.array,
    onCommunicatorChanged: React.PropTypes.func,
    onPeriodChanged: React.PropTypes.func,
    selectedCommunicator: React.PropTypes.string,
    periodStart: React.PropTypes.string,
    periodEnd: React.PropTypes.string
};

const mapStateToProps = (state, ownProps) => ({
    communicators: state.compliance.monitor.communicators,
    selectedCommunicator: ownProps.location.query.communicatorId,
    periodStart: ownProps.location.query.periodStart,
    periodEnd: ownProps.location.query.periodEnd,
    selectedCommunication: state.compliance.monitor.searchResults.selectedCommunication
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCommunicators: () => dispatch(loadCommunicators()),
    onCommunicatorChanged: communicator => {
        const queryParams = Object.assign({}, ownProps.location.query);
        if (communicator === null) {
            delete queryParams.communicatorId;
        } else {
            queryParams.communicatorId = communicator.value;
        }

        ownProps.router.push(`${COMPLIANCE_COMMUNICATIONS_ROUTE}?${stringify(queryParams)}`);
        dispatch(searchCommunications(communicator && communicator.value, { periodStart: queryParams.periodStart, periodEnd: queryParams.periodEnd }));
    },
    onPeriodChanged: period => {
        let periodParams = {};

        let queryParams = Object.assign({}, ownProps.location.query);
        if (period === RANGE_BLANK) {
            delete queryParams.periodStart;
            delete queryParams.periodEnd;
        } else {
            periodParams = {
                periodStart: period.range.from.toString(),
                periodEnd: period.range.to.toString()
            };
            queryParams = Object.assign(queryParams, periodParams);
        }

        ownProps.router.push(`${COMPLIANCE_COMMUNICATIONS_ROUTE}?${stringify(queryParams)}`);
        dispatch(searchCommunications(queryParams.communicatorId, periodParams));
    }
});

const CommunicationsFilterContainer = connect(mapStateToProps, mapDispatchToProps)(CommunicationsFilter);
CommunicationsFilterContainer.propTypes = {
    location: React.PropTypes.object,
    router: React.PropTypes.object.isRequired
};
CommunicationsFilterContainer.defaultProps = {
    location: {
        query: {}
    }
};

export default CommunicationsFilterContainer;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/CommunicationsFilter.js
 **/